import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { dgWithReducer } from 'dg-utils';
import { U as UserForm } from './user.form-377bc838.js';
import { updateUser, setCurrentUser, getUserById } from './userActions.mjs';
import userReducer from './userReducer.mjs';
import 'redux-form';
import 'dg-forms';
import './types-0b7e03a3.js';
import 'qs';
import '@babel/runtime/helpers/defineProperty';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditUserPage = /*#__PURE__*/function (_Component) {
  _inherits(EditUserPage, _Component);

  var _super = _createSuper(EditUserPage);

  function EditUserPage(props) {
    var _this;

    _classCallCheck(this, EditUserPage);

    _this = _super.call(this, props);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EditUserPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var urlParams = window.location.pathname;
      var params = urlParams.split("/");

      if (params.length >= 4) {
        this.props.getUserById(params[4]).then(function (res) {
          _this2.props.setCurrentUser(res.user);
        })["catch"](function (res) {
          Swal.fire("Error", res.message, "error");
        });
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(data) {
      var _this3 = this;

      this.props.updateUser(data).then(function (res) {
        Swal.fire("User Updated", res.message, "success");

        _this3.props.navigate("/admin/user");
      })["catch"](function (res) {
        Swal.fire("Error", res.message, "error");
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("main", {
        className: "dg-admin-main"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-List-Container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-header-container"
      }, /*#__PURE__*/React.createElement("h1", null, "Edit a User"))), /*#__PURE__*/React.createElement(UserForm, {
        type: "Admin",
        initialValues: this.props.users.currentUser,
        enableReinitialize: true,
        onSubmit: this.props.onSubmit || this.onSubmit,
        editingExistingUser: true
      }));
    }
  }]);

  return EditUserPage;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    users: state.users
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateUser: function updateUser$1(data) {
      return dispatch(updateUser(data));
    },
    setCurrentUser: function setCurrentUser$1(data) {
      return dispatch(setCurrentUser(data));
    },
    getUserById: function getUserById$1(page, page_size) {
      return dispatch(getUserById(page));
    }
  };
};

var editUser_component = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(EditUserPage, "users", userReducer));

export { editUser_component as default };
